import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DeclarationAcceptance, DeclarationService } from '../../services/declaration.service';
import { PRIVACYNOTICEURL } from '../../constants';

/** Un párrafo de la declaración, con el enlace al aviso de privacidad si lo menciona. */
interface DeclarationParagraph
{
  before: string;
  link: string;
  after: string;
}

/**
 * Casilla homologada de la declaración del doctor. Es la misma en la Confirmación del caso,
 * la edición de la prescripción y los wizards de accesorios. Muestra el texto que manda el
 * servidor y avisa al padre qué versión aceptó, para que la mande al enviar.
 */
@Component({
  selector: 'app-declaration-confirmation',
  templateUrl: './declaration-confirmation.component.html',
  styleUrls: ['./declaration-confirmation.component.css']
})
export class DeclarationConfirmationComponent implements OnInit
{
  /** Estado inicial, p. ej. al regresar a un paso que ya se había confirmado. */
  @Input() public checked: boolean = false;

  @Output() public acceptedChange: EventEmitter<DeclarationAcceptance> = new EventEmitter<DeclarationAcceptance>();

  public readonly privacyUrl: string = PRIVACYNOTICEURL;
  private readonly privacyPhrase: string = 'aviso de privacidad';

  public version: string = null;
  public paragraphs: DeclarationParagraph[] = [];
  public loadError: boolean = false;

  constructor(private declarationService: DeclarationService) { }

  ngOnInit(): void
  {
    this.load();
  }

  public load(): void
  {
    this.loadError = false;

    this.declarationService.getCurrent().subscribe(
      declaration =>
      {
        // El servidor separa los párrafos con una línea en blanco
        this.paragraphs = declaration.text
          .split(/\n\s*\n/)
          .map(paragraph => this.toParagraph(paragraph.trim()));
        this.version = declaration.version;

        // Si ya venía marcada, el padre necesita la versión para poder enviarla
        if (this.checked)
        {
          this.emit();
        }
      },
      () => this.loadError = true);
  }

  public onChange(checked: boolean): void
  {
    this.checked = checked;
    this.emit();
  }

  /** El enlace va sobre la frase "Aviso de Privacidad", respetando cómo viene escrita. */
  private toParagraph(text: string): DeclarationParagraph
  {
    const index = text.toLowerCase().indexOf(this.privacyPhrase);
    if (index < 0)
    {
      return { before: text, link: null, after: '' };
    }

    return {
      before: text.substring(0, index),
      link: text.substring(index, index + this.privacyPhrase.length),
      after: text.substring(index + this.privacyPhrase.length),
    };
  }

  private emit(): void
  {
    this.acceptedChange.emit({ accepted: this.checked, version: this.version });
  }
}
